// extracted by mini-css-extract-plugin
module.exports = {"itemTypeAndDuration":"style-module__itemTypeAndDuration___36ttQ","name":"style-module__name___2LvMb","lock":"style-module__lock___2FqXS"};